import FilterComponent from "../components/Inputs/AppFilter";
import { IoIosLogOut } from "react-icons/io";
import { CiUser } from "react-icons/ci";
import { useAuth0 } from "@auth0/auth0-react";
import { useAppDispatch } from "../store/hooks";
import { logout as appLogout } from "../store/authSlice";
import { IconWrapper } from "../customHooks/useIcon";
import { Link } from "react-router-dom";
import { PAGE_PADDING } from "../utils/constants";
import { forwardRef, useEffect, useState } from "react";
import LanguageSwitcher from "./switchLanguage";

interface NavBarProps {
  showDateFilter?: boolean;
  isSidebarOpen: boolean;
}
const NavBar = forwardRef<HTMLDivElement, NavBarProps>(function NavBar(
  { showDateFilter }: NavBarProps,
  ref
) {
  const { logout } = useAuth0();
  const dispatch = useAppDispatch();
  const handleLogout = () => {
    logout({
      logoutParams: { returnTo: `${window.location.origin}/auth/login` },
    });
    dispatch(appLogout());
  };
  const [showShadow, setShowShadow] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShowShadow(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <nav
      ref={ref}
      className={`bg-white items-start flex flex-col lg:flex-row lg:items-center justify-between min-h-[5rem] ${
        showShadow ? "shadow-md" : ""
      } gap-6 lg:gap-4`}
      style={{
        padding: PAGE_PADDING,
        paddingBottom: "20px",
      }}
    >
      {showDateFilter && (
        <div className="lg:max-w-[70%] flex-1">
          <FilterComponent />
        </div>
      )}

      <div
        className={`flex  items-center gap-2 ${
          showDateFilter ? "justify-center" : "ml-auto"
        } cursor-pointer`}
      >
        <LanguageSwitcher />
        {/* <span className="rounded-full border border-primary-border min-w-fit px-2 py-1 flex items-center justify-between text-primary-blackLighter hover:bg-primary-blackLighter2 hover:text-primary-blackMain">
        </span> */}
        <Link
          to={"/dashboard/my-account"}
          className="h-50 w-50 rounded-full border border-primary-border p-1 flex items-center justify-center hover:bg-primary-blackLighter2 hover:text-primary-blackMain"
        >
          <IconWrapper icon={CiUser} size={22} />
        </Link>
        <span className="h-50 w-50 rounded-full border border-primary-border p-1 flex items-center justify-center text-primary-blackLighter hover:bg-primary-blackLighter2 hover:text-primary-blackMain">
          <IconWrapper
            icon={IoIosLogOut}
            size={22}
            className=""
            onClick={handleLogout}
          />
        </span>
      </div>
    </nav>
  );
});

export default NavBar;
